import { CartItem } from "@omni/types/api/cart/bff/shared/cartItem.model";
import { ProductConfiguration } from "@omni/types/utils/productConfiguration";
import * as CartUtils from "@omni/utils/cart.utils";

import { Tooltip } from "@/components/General/Tooltip/tooltip.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { Config } from "@/utils/config.utils";
import { getProductConfigurationPreview } from "@/utils/productConfiguration";
import { productConfigurations } from "@/utils/productConfiguration/productConfiguration.utils";

type CartItemInfoTitleProps = {
    isWarrantyDeposit: boolean;
    isConfigurableProduct: boolean;
    cartItem: CartItem;
    warrantyDepositTooltipInfo: string;
    productConfiguration?: ProductConfiguration;
};

const CartItemInfoTitle = ({
    isConfigurableProduct,
    isWarrantyDeposit,
    cartItem,
    warrantyDepositTooltipInfo,
    productConfiguration
}: CartItemInfoTitleProps) => {
    const { t } = useGranite();
    if (isWarrantyDeposit) {
        return (
            <>
                {CartUtils.getTitle(cartItem, t)}
                {warrantyDepositTooltipInfo && (
                    <Tooltip innerHTML={warrantyDepositTooltipInfo} />
                )}
            </>
        );
    }

    if (isConfigurableProduct) {
        return (
            <span className="h3 text-secondary-link-color">
                {CartUtils.getTitle(cartItem, t)}
            </span>
        );
    }

    const productUrl = CartUtils.getUrl(
        cartItem,
        productConfigurations,
        Config.pages.giftcard
    );
    return (
        <>
            {productUrl && (
                <a
                    href={productUrl}
                    className="h3"
                >
                    {CartUtils.getTitle(cartItem, t)}{" "}
                    {getProductConfigurationPreview(
                        cartItem,
                        productConfiguration
                    )}
                </a>
            )}
        </>
    );
};

export { CartItemInfoTitle };
